import request from '@/utils/request'


// 查询赛事红包信息列表
export function listCompetitionPacket(query) {
  return request({
    url: '/platform/competition-packet/list',
    method: 'get',
    params: query
  })
}

// 查询赛事红包信息分页
export function pageCompetitionPacket(query) {
  return request({
    url: '/platform/competition-packet/page',
    method: 'get',
    params: query
  })
}

// 查询赛事红包信息详细
export function getCompetitionPacket(data) {
  return request({
    url: '/platform/competition-packet/detail',
    method: 'get',
    params: data
  })
}

// 新增赛事红包信息
export function addCompetitionPacket(data) {
  return request({
    url: '/platform/competition-packet/add',
    method: 'post',
    data: data
  })
}

// 修改赛事红包信息
export function updateCompetitionPacket(data) {
  return request({
    url: '/platform/competition-packet/edit',
    method: 'post',
    data: data
  })
}

// 删除赛事红包信息
export function delCompetitionPacket(data) {
  return request({
    url: '/platform/competition-packet/delete',
    method: 'post',
    data: data
  })
}
